import React from 'react';
import './ScorecardList.styl';
import {TrashIcon} from '@components/icon/TrashIcon';

// TODO: a must be replaced with button and eslint ignore must be removed.
//  Figure out why GenericLink makes the whole <li> clickable...
/* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
export default class ScorecardList extends React.PureComponent {
  render() {
    return (
      <ul className="scorecard-list">
        {this.props.scorecards.map(card => (
          <li key={card.id}>
            <a href="javascript:;" onClick={() => this.props.onEditScorecard(card)}>
              {card.name}
            </a>
            <TrashIcon onClick={() => this.props.onDelete(card)} tooltip="Delete" />
          </li>
        ))}
      </ul>
    );
  }
}
